import { Button } from "components/DesignSystem/Button/Button";
import {
  TIMELINE_EMPTY_TITLE,
  TIMELINE_JUMP_YEAR_PREFIX,
} from "constants/filingsTimeline";

type TimelineEmptyStateProps = {
  subtext?: string;
  jumpYear?: number;
  onJumpToYear?: () => void;
};

export const TimelineEmptyState = ({
  subtext,
  jumpYear,
  onJumpToYear,
}: TimelineEmptyStateProps) => (
  <div className="t-flex t-h-[149px] t-flex-col t-items-center t-justify-center t-gap-0.5 t-px-6 t-text-center">
    <div className="t-text-subtitle t-text-text-30">{TIMELINE_EMPTY_TITLE}</div>

    {subtext && (
      <div className="t-text-body-sm t-text-neutral-40">{subtext}</div>
    )}

    {Boolean(jumpYear) && onJumpToYear && (
      <div className="t-mt-2">
        <Button customType="secondary" size="small" onClick={onJumpToYear}>
          {TIMELINE_JUMP_YEAR_PREFIX} {jumpYear}
        </Button>
      </div>
    )}
  </div>
);
